const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const OrderPrioCommand: any = {
    AddOrUpdateOrderPrio: Backofficebff + '/v1/postcheckout/add-or-update-order-priority-list',
};
